import { TranslationFunction } from '@/src/types/translations'
import { memo } from 'react'
import InsuranceFooter from './insuranceFooter'

interface InsuranceFooterWrapperProps {
    insuranceTermsAndConditionsError: boolean
    isInsuranceTermsAndConditionsChecked: boolean
    termsAndConditionsUrl: string
    onTermsChange: () => void
    t: TranslationFunction<'common'>
}

const InsuranceFooterWrapper: React.FC<InsuranceFooterWrapperProps> = ({
    insuranceTermsAndConditionsError,
    isInsuranceTermsAndConditionsChecked,
    termsAndConditionsUrl,
    onTermsChange,
    t
}) => {
    return (
        <InsuranceFooter
            insuranceTermsAndConditionsError={insuranceTermsAndConditionsError}
            termsAndConditionsUrl={termsAndConditionsUrl}
            isInsuranceTermsAndConditionsChecked={isInsuranceTermsAndConditionsChecked}
            onTermsChange={onTermsChange}
            t={t}
        />
    )
}

export default memo(InsuranceFooterWrapper)
